module.exports = __webpack_public_path__ + "img/ethernet.0bab9312.svg";